module.exports = __webpack_public_path__ + "static/img/jiucai.1ecd4c28.png";